import React from 'react'

const THETAUSD = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none'>
      <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
      <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
      <path
        d='M16.08 10.3198H31.92V37.6798H16.08V10.3198Z'
        stroke='url(#paint0_linear_646_6658)'
        strokeWidth='3.01768'
        strokeLinejoin='bevel'
      />
      <path
        d='M28.7994 28.3197H25.5193V31.7562H22.5595V28.3197H19.2793V25.3599H28.7994V28.3197ZM28.7994 19.8393H25.5193V16.4028H22.5595V19.8393H19.2793V22.7991H28.7994V19.8393Z'
        fill='url(#paint1_linear_646_6658)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_646_6658'
          x1='12.4451'
          y1='12.4449'
          x2='35.5538'
          y2='35.5536'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2AB8E6' />
          <stop offset='0.53' stopColor='#29CAD2' />
          <stop offset='1' stopColor='#2EE4BE' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_646_6658'
          x1='19.46'
          y1='19.5001'
          x2='28.6199'
          y2='28.66'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2AB8E6' />
          <stop offset='0.53' stopColor='#29CAD2' />
          <stop offset='1' stopColor='#2EE4BE' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default THETAUSD
